import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/dental/DentalPageClient.tsx");
